import React from 'react';
import UIImage from './image';
import UIVideo from './video';
import isVideo from '../../utils/isVideo';

const UIMedia = ({
  media, alt, mediaSizePolicy, sourceMediaSizeSpec, breakpoints, breakpointFlags, borderRadius, fullScreen, position,
  fallbackTransparent, showFullHeightVideo
  }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', position: position }}>
      {isVideo(media)
        ? <UIVideo videoSizePolicy={mediaSizePolicy} sourceVideoSizeSpec={sourceMediaSizeSpec} breakpoints={breakpoints}
            srcRoute={media} alt={alt} breakpointFlags={breakpointFlags} borderRadius={borderRadius}
            fullScreen={fullScreen} fallbackTransparent={fallbackTransparent}
            showFullHeightVideo={showFullHeightVideo} />
        : <UIImage imageSizePolicy={mediaSizePolicy} sourceImageSizeSpec={sourceMediaSizeSpec} breakpoints={breakpoints}
            srcRoute={media} breakpointFlags={breakpointFlags} borderRadius={borderRadius} alt={alt}
            fallbackTransparent={fallbackTransparent} />}
    </div>
  );
};

UIMedia.defaultProps = {
  borderRadius: '0'
};

export default UIMedia;
